var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "55px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "55px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guides"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#107B10",
    height: 280,
    width: 288,
    x: 112,
    y: 120
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#066306",
    points: "384,96 128,96 112,120 400,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#229922",
    points: "117.333,112 112,120 400,120 394.666,112"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "264,352 160,320 160,200 264,168  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,200v16h24v8h-24v12h24v8h-24v12h24v8h-24v12h24v8h-24v12h24v8h-24v16h80V200H272z M336,304h-32v-8h32   V304z M336,284h-32v-8h32V284z M336,264h-32v-8h32V264z M336,244h-32v-8h32V244z M336,224h-32v-8h32V224z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#107B10",
    points: "234.408,229.194 216.403,230.99 206.001,250.839 196.199,233.007 182.108,234.414    197.224,261.302 181.121,289.575 195.109,290.972 206.001,271.899 217.744,293.23 235.813,295.034 215.322,261.163    234.408,229.194  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelicon);
export default __webpack_public_path__ + "static/media/excelicon.ea0cfd13539a69297b3b422a9822ba17.svg";
export { ForwardRef as ReactComponent };